<template>
  <div>
    <ul class="nav nav-tabs">
      <li
        class="nav-item"
        v-for="item in tabs"
        :key="item.id">
        <a
          v-if="userCanView(item.id)"
          :class="'nav-link ' + (item.id === tab ? 'active' : '')"
          href="#"
          @click="setTab(item.id)">
          {{ item.title }}
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link"
           :href=client.fileUrl
           target="_blank">
          Файлы
        </a>
      </li>
    </ul>

    <Drug v-if="tab === 'drug'" :client="client"/>
    <Checkup v-if="tab === 'checkup'" :client="client"/>
    <Health v-if="tab === 'health'" :client="client"/>
    <Test v-if="tab === 'test'" :client="client"/>

    <Questionnaire
      v-if="userCanView('questionnaire') && tab === 'questionnaire'"
      :client="client"/>

    <Note v-if="tab === 'note'" :client="client"/>
    <Conclusion v-if="tab === 'conclusion'" :client="client"/>
    <Strategy v-if="tab === 'strategy'" :client="client"/>
  </div>
</template>

<script>
import Drug from './Drug';
import Checkup from './Checkup';
import Test from './Test';
import Health from './Health';
import Questionnaire from './Questionnaire';
import Note from './Note';
import Conclusion from './Conclusion';
import Strategy from './Strategy';

export default {
  name: 'ClientItem',

  components: {Drug, Checkup, Test, Health, Questionnaire, Note, Conclusion, Strategy},

  props: ['client'],

  data() {
    return {
      tab: 'drug',
      tabs: [
        {id: 'drug', title: 'Назначения'},
        {id: 'health', title: 'Статус здоровья'},
        {id: 'conclusion', title: 'Заключения'},
        {id: 'test', title: 'Анализы'},
        {id: 'questionnaire', title: 'Анкеты'},
        {id: 'checkup', title: 'Метрики'},
        {id: 'strategy', title: 'Стратегии'},
        {id: 'note', title: 'Заметки'},
      ],
    };
  },

  methods: {
    setTab(tab) {
      this.tab = tab;
    },

    userCanView(view) {
      const {voters} = this.$security;

      switch (view) {
        case 'questionnaire':
          return voters.questionnaire.canView(this.$store.state.user);
        default:
          return true;
      }
    },
  },
};
</script>
